import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Calculator.html?raw';
import lang from 'dojo/_base/lang';

import _uiFrameMixin from '../../Container/uiFrame';
interface HistoryEntry {
    left: string,
    operator: string,
    right?: number
}
class Calculator extends compose(_uiFrameMixin) {
    templateString: any = template;

    private lastOperation_history: HTMLElement;
    private history: Array<HistoryEntry> = [];
    private screen: HTMLElement;

    private _currentValueStr: string = "0";
    private previousValue: number = null;
    private operator: string = null;
    private resetScreen: boolean = false;

    private _initialValue: number;
    private _currentValue: number;

    setValue(val: number, operator?: string) {
        let strVal = "";
        if (typeof (val) == "number") strVal = val.toString();

        this._currentValueStr = strVal;
        this._initialValue = val;
        this._currentValue = val;
        this._updateValues();       

        switch (operator) {
            case "+":
            case "-":
            case "*":
            case "x":
            case "/":
                this._setOperator(operator);
                break;
        }
        
    }

    protected onShow() {
        this.domNode.focus();
    }

    //protected _setupFrameContainers() {
    //    let self = this as any;
    //    self.inherited(arguments);

    //    // bissl umsortieren:
    //    //this.UiModder.domConstruct.place(this._uiFrame_ActionBar, this.domNode, "last");
    //    this.UiModder.domConstruct.place(this._uiFrame_TopContainer, this.domNode, "last");
    //    this.UiModder.domConstruct.place(this._uiFrame_BottomContainer, this.domNode, "last");
    //}

    private _updateValues(): void {
        let value = parseFloat(this._currentValueStr);
        if (!isNaN(value)) this._currentValue = value;

        this._drawHistory();

        this.screen.innerHTML = this._currentValueStr;        
    }

    private _number(evt: any): void {
        const value = evt.target.value;

        if (this.resetScreen) {
            this._currentValueStr = value === "." ? "0." : value;
            this.resetScreen = false;
        } else {
            if (value === "." && this._currentValueStr.includes(".")) return;
            this._currentValueStr = this._currentValueStr === "0" && value !== "."
                ? value
                : this._currentValueStr + value;
        }

        this._updateValues();
    }

    private _add(): void { this._setOperator("+"); }
    private _substract(): void { this._setOperator("-"); }
    private _multiply(): void { this._setOperator("*"); }
    private _divide(): void { this._setOperator("/"); }

    private _equal(): void {
        if (!this.operator || this.previousValue === null) return;
        const right = parseFloat(this._currentValueStr);

        this._compute();

        const last = this.history[this.history.length - 1];
        if (last?.right === null) last.right = right;

        this.operator = null;
        this.previousValue = this._currentValue;

        this._drawHistory();

        this.enableButton("confirmValue", this._currentValue != this._initialValue);
    }

    private _drawHistory() {
        if (this.history.length == 0) {
            this.lastOperation_history.innerHTML = "";
            return;
        }

        let lines: string[] = [];

        for (let entry of this.history) {
            if (entry.right !== null) {
                lines.push(`${entry.left} ${entry.operator} ${entry.right}`);
            } else {
                // currently active operation
                lines.push(`${entry.left} ${entry.operator} ${this._currentValueStr}`);
            }
        }

        this.lastOperation_history.innerHTML = lines.join("\n");
        this.lastOperation_history.scrollBy(0, this.lastOperation_history.clientHeight);
    }

    private _setOperator(op: string): void {

        if (this.resetScreen) {
            this.operator = op;

            const last = this.history[this.history.length - 1];
            if (last?.right === null) {
                last.operator = op;
            }

            this._drawHistory();
            return;
        }

        const current = parseFloat(this._currentValueStr);

        if (this.operator && this.previousValue !== null) {
            this._compute();

            const last = this.history[this.history.length - 1];
            if (last?.right === null) {
                last.right = current;
            }
        }

        this.previousValue = parseFloat(this._currentValueStr);
        this.operator = op;

        this.history.push({
            left: this._currentValueStr,
            operator: op,
            right: null
        });

        this.resetScreen = true;

        this._drawHistory();        
    }

    private _backspace(): void {
        if (this._currentValueStr.length > 1) {
            this._currentValueStr = this._currentValueStr.slice(0, -1);
        } else {
            this._currentValueStr = "0";
        }
        this._updateValues();
    }

    private _clear(): void {
        this._currentValueStr = "0";
        this._currentValue = 0;
        this.previousValue = null;
        this.operator = null;
        this.resetScreen = false;
        this.history = [];
        this._drawHistory();
        //this.lastOperation_history.innerHTML = "";
        this._updateValues();
    }

    private _clearEntry(): void {
        this._currentValueStr = "0";
        //this.history.push("");
        //this.history[this.history.length - 1] = "0";
        this._updateValues();
    }

    private _plus_minus(): void {
        if (this._currentValueStr !== "0") {
            this._currentValueStr = this._currentValueStr.startsWith("-")
                ? this._currentValueStr.slice(1)
                : "-" + this._currentValueStr;
        }
        this._updateValues();
    }

    private _compute(): void {
        if (this.operator === null || this.previousValue === null) return;

        const current = parseFloat(this._currentValueStr);
        let result: number = current;

        switch (this.operator) {
            case "+":
                result = this.previousValue + current;
                break;
            case "-":
                result = this.previousValue - current;
                break;
            case "*":
                result = this.previousValue * current;
                break;
            case "/":
                result = current === 0 ? 0 : this.previousValue / current;
                break;
        }

        this._currentValueStr = result.toString();
        this._updateValues();
    }

    private _onKeyUp(e: KeyboardEvent): void {
        e.stopPropagation();
        e.preventDefault();
    }
    private _handleKey(e: KeyboardEvent): void {
        e.preventDefault();
        const key = e.key;

        this._highlightButton(`[data-key="${key === "=" ? "Enter" : key === "," ? "." : key}"]`);

        // Numbers
        if (!isNaN(Number(key))) {
            this._number({ target: { value: key } });
            return;
        }

        // Decimal
        if (key === "." || key === "," ) {
            this._number({ target: { value: "." } });
            return;
        }

        // Operators
        switch (key) {
            case "+":
                this._add();
                break;
            case "-":
                this._substract();
                break;
            case "*":
                this._multiply();
                break;
            case "/":
                this._divide();
                break;
            case "Enter":
            case "=":
                if (this.operator !== null && this.previousValue !== null) this._equal();
                else this.emitCurrentValue();
                //if (!this._inputStr) this.emitCurrentValue();
                //else this._equal();
                break;
            case "Backspace":
                this._backspace();
                break;
            case "Escape":
                if (this.previousValue == 0 && this.history.length == 1) this.close(); // ist schon resettet -> raus
                else this._clear();
                //this.close();
                break;
            case "Delete":
                this._clearEntry();
                break;

        }

        e.stopPropagation();
        e.preventDefault();

    }

    private _highlightButton(selector: string): void {
        const btn = this.domNode.querySelector(selector) as HTMLElement;
        if (!btn) return;

        btn.classList.add("active");

        setTimeout(() => {
            btn.classList.remove("active");
        }, 100);
    }

    private emitCurrentValue() {

        let numberVal = this._currentValue;// parseFloat(this._currentValueStr);
        this.emit("calculatorValue", { stringVal: this._currentValueStr, numberVal: numberVal });

        this.close();
    }

    getValue(bString: false): number
    getValue(bString: true): string
    getValue(): number
    getValue(bString?: boolean): string | number {
        if (bString) return this._currentValueStr;
        return this._currentValue;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._initialValue = 0;

        //this.addButton("takeValue", this.translate("NumberInput_Calc_Label_ImportValue"), lang.hitch(this, this.emitCurrentValue), null, "accentBG");
        this.addButtonEx({
            callback: lang.hitch(this, this.close),
            internalName: "closeCalculator",
            iconClass: "fas fa-times",
            styleClass: "secondaryBtn w3-block",
            label: ""
        });

        this.addButtonEx({
            callback: lang.hitch(this, this.emitCurrentValue),
            internalName: "confirmValue",
            iconClass: "fas fa-check",
            styleClass: "primaryBtn w3-block",
            label: "",
            enabled: false
        });
        
        this.domNode.addEventListener("keydown", lang.hitch(this, this._handleKey));
        this.domNode.addEventListener("keyup", lang.hitch(this, this._onKeyUp));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(Calculator);